/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type UpdateHardwareRequestItemQuantitiesMutationVariables = Types.Exact<{
  request_id: Types.Scalars["Float"];
  updates:
    | Array<Types.HardwareItemQuantityUpdate>
    | Types.HardwareItemQuantityUpdate;
}>;

export type UpdateHardwareRequestItemQuantitiesMutation = {
  updateHardwareRequestItemQuantities: Pick<Types.Success, "status">;
};

export const UpdateHardwareRequestItemQuantitiesDocument = gql`
  mutation UpdateHardwareRequestItemQuantities(
    $request_id: Float!
    $updates: [HardwareItemQuantityUpdate!]!
  ) {
    updateHardwareRequestItemQuantities(
      request_id: $request_id
      updates: $updates
    ) {
      status
    }
  }
`;

/**
 * __useUpdateHardwareRequestItemQuantitiesMutation__
 *
 * To run a mutation, you first call `useUpdateHardwareRequestItemQuantitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHardwareRequestItemQuantitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHardwareRequestItemQuantitiesMutation, { data, loading, error }] = useUpdateHardwareRequestItemQuantitiesMutation({
 *   variables: {
 *      request_id: // value for 'request_id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateHardwareRequestItemQuantitiesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateHardwareRequestItemQuantitiesMutation,
    UpdateHardwareRequestItemQuantitiesMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateHardwareRequestItemQuantitiesMutation,
    UpdateHardwareRequestItemQuantitiesMutationVariables
  >(UpdateHardwareRequestItemQuantitiesDocument, baseOptions);
}
export type UpdateHardwareRequestItemQuantitiesMutationHookResult = ReturnType<
  typeof useUpdateHardwareRequestItemQuantitiesMutation
>;
export type UpdateHardwareRequestItemQuantitiesMutationResult =
  ApolloReactCommon.MutationResult<UpdateHardwareRequestItemQuantitiesMutation>;
export type UpdateHardwareRequestItemQuantitiesMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateHardwareRequestItemQuantitiesMutation,
    UpdateHardwareRequestItemQuantitiesMutationVariables
  >;
